import { DefaultTheme } from 'styled-components'
import { colors as customColors } from '@diversioteam/diversio-ds'

import { columnsSpacing } from './columnsSpacing'

export const theme: DefaultTheme = {
    colors: customColors,
    columnsSpacing,
}
